module.exports = __webpack_public_path__ + "static/media/success6_500x620.9f13f6c7.jpg";